import { memo, useState } from "react";
import TextArea from "/src/components/UI/TextField/TextArea";
import { SCORE_LEVELS } from "../../data/scorecard";
import { Field } from "../shared";
import { weightedScore } from "../../utils/scoring";

function DimensionCard({ dimension, score, evidence, coaching, onScore, onNote }) {
    const hasNotes = Boolean(evidence || coaching);
    const [open, setOpen] = useState(hasNotes);

    const weighted = weightedScore(score, dimension.weight);
    const maxPoints = dimension.weight * 100;
    const scored = score !== null && score !== undefined;

    return (
        <article className={"ce-dim" + (scored ? " is-scored s" + score : "")}>
            <div className="ce-dim__top">
                <span className="ce-dim__index">{String(dimension.id).padStart(2, "0")}</span>
                <div className="ce-dim__title">
                    <h4>{dimension.name}</h4>
                    <span className="ce-chip">Weight {maxPoints.toFixed(0)}%</span>
                </div>
            </div>

            <p className="ce-dim__desc">{dimension.description}</p>

            <div className="ce-dim__controls">
                <div className="ce-segment" role="group" aria-label={`Score for ${dimension.name}`}>
                    {SCORE_LEVELS.map((level) => (
                        <button
                            key={level.value}
                            type="button"
                            title={level.label}
                            className={"ce-segment__btn s" + level.value + (score === level.value ? " is-active" : "")}
                            aria-pressed={score === level.value}
                            onClick={() => onScore(dimension.id, level.value)}
                        >
                            <b>{level.value}</b>
                            <small>{level.short}</small>
                        </button>
                    ))}
                </div>

                <div className="ce-dim__points">
                    <div className="ce-bar">
                        <span className={scored ? "s" + score : ""} style={{ width: scored ? `${(score / 3) * 100}%` : 0 }} />
                    </div>
                    <span className="ce-dim__pts">
                        {weighted === null ? "—" : (weighted * 100).toFixed(1)} <small>/ {maxPoints.toFixed(0)} pts</small>
                        {scored && <small className="ce-dim__level"> · {SCORE_LEVELS[score].label}</small>}
                    </span>
                </div>

                <button
                    type="button"
                    className={"ce-iconbtn" + (open || hasNotes ? " is-on" : "")}
                    title="Evidence & coaching notes"
                    aria-expanded={open}
                    onClick={() => setOpen((value) => !value)}
                >
                    <i className="fas fa-sticky-note"></i>
                    {hasNotes && <span className="ce-iconbtn__dot" />}
                </button>
            </div>

            {open && (
                <div className="ce-dim__notes">
                    <Field label="Timestamp / Evidence">
                        <TextArea
                            className="input ce-w100"
                            rows={2}
                            placeholder="e.g. 04:12 – never asked about previous experience"
                            value={evidence || ""}
                            onChange={(event) => onNote("evidence", dimension.id, event.target.value)}
                        />
                    </Field>
                    <Field label="Coaching notes">
                        <TextArea
                            className="input ce-w100"
                            rows={2}
                            placeholder="What to work on next"
                            value={coaching || ""}
                            onChange={(event) => onNote("coaching", dimension.id, event.target.value)}
                        />
                    </Field>
                </div>
            )}
        </article>
    );
}

export default memo(DimensionCard);
